const createService = {
  select: 'SELECCIONAR',
  step0: 'Seleccione el equipo',
  step1: 'Seleccione el tipo de servicio',
  step2: 'Completa el Checklist',
  draftListTitle: 'Borradores de Servicios',
  draftListDescription: 'Existen servicios similares ya iniciados y no finalizados para este equipo',
  draftListButton: 'VER',
  toastrSucessDeleteDraftTitle: 'Borrador eliminado con éxito',
  toastrErrorDeleteDraftTitle: 'Error al eliminar el borrador',
  savingDraft: 'Guardando borrador...',
  lastSavedDraft: 'Ultimo borrador guardado ', 
};

export default createService;